var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClaimType(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "claim-type",
    transform: "translate(0 -1)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Boundary",
    width: 21,
    height: 20,
    transform: "translate(0 1)",
    fill: "#9e9e9e",
    opacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_clipboard-check",
    "data-name": "Path / clipboard-check",
    d: "M9.166,15.093,5.642,11.57l1.242-1.242L9.166,12.6l5.8-5.8,1.242,1.251M10.927,2.762a.881.881,0,1,1-.881.881.881.881,0,0,1,.881-.881m6.166,0H13.411a2.632,2.632,0,0,0-4.968,0H4.762A1.762,1.762,0,0,0,3,4.523V16.855a1.762,1.762,0,0,0,1.762,1.762H17.093a1.762,1.762,0,0,0,1.762-1.762V4.523A1.762,1.762,0,0,0,17.093,2.762Z",
    transform: "translate(-0.358 0.621)",
    fill: "#9e9e9e"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClaimType);
export default __webpack_public_path__ + "static/media/claim-type.1ffa866945c7de029ec36eec1025b3a4.svg";
export { ForwardRef as ReactComponent };